import { logUsage } from 'owa-analytics';
import { DomainConnectFetchSetupResponse } from 'owa-domain-connect';

export function traceManageDomainButtonClick() {
    logUsage('DomainDashboardManageDomain', null, { isCore: true });
}

export function traceRemoveDomainButtonClick() {
    logUsage('DomainDashboardRemoveDomain', null, { isCore: true });
}

export function traceCreateEmailButtonClick() {
    logUsage('DomainDashboardCreateEmail', null, { isCore: true });
}

export function traceStartEnrollDomainClick() {
    logUsage('DomainDashboardGetStarted', null, { isCore: true });
}

export function traceDomainStatus(message: DomainConnectFetchSetupResponse) {
    logUsage(
        'DomainDashboarDomainStatus',
        {
            dnsValue: message.domainData.dnsRecordValue,
            domainName: message.domainData.domainName,
            isDomainValid: message.domainData.isDomainValidated,
            isDomainExisted: message.domainData.isDomainExisted,
            purchaseType: message.domainData.domainPurchaseType.toString(),
            purchaseDate: message.domainData.domainPurchaseDate.toString(),
        },
        { isCore: true }
    );
}

export function traceDomainUIStatue(isAliasAdded: boolean, uiStatus: string) {
    logUsage('DomainDashboarDomainUIStatus', { isAliasAdded, uiStatus }, { isCore: true });
}

export function traceSecondaryUserEmailRemoveButtonClick() {
    logUsage('DomainDashboarRemoveSecondaryUserEmail', null, {
        isCore: true,
    });
}
